export default __webpack_public_path__ + "static/banner-renovation-sustain-cfaccd5c831a5ad7f4f4eec55985bd2f.jpg";